import * as React from "react";
import type { SVGProps } from "react";
const SvgTicketVertical = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 5a3 3 0 0 1 3-3h3a1 1 0 0 1 1 .995V3q0 .014.002.05a2.65 2.65 0 0 0 .176.828c.086.213.191.367.306.462.097.08.244.159.516.159s.42-.078.516-.159c.115-.095.22-.249.306-.462a2.7 2.7 0 0 0 .176-.829L13 3.001v-.006A1 1 0 0 1 14 2h3a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3zm10.873-1a4.4 4.4 0 0 1-.194.621c-.165.412-.435.883-.883 1.257-.465.388-1.068.622-1.796.622s-1.33-.234-1.796-.622c-.448-.374-.718-.845-.882-1.257A4.4 4.4 0 0 1 9.127 4H7a1 1 0 0 0-1 1v5h2a1 1 0 1 1 0 2H6v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-7h-2a1 1 0 1 1 0-2h2V5a1 1 0 0 0-1-1zM10 11a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTicketVertical;
